export const STATUS_STATES: Record<string, string> = {
  Starting_Operation: $localize`Starting operation …`,
  Backup_Begin: $localize`Starting backup …`,
  Backup_PreBackupVerify: $localize`Verifying backend data …`,
  Backup_PostBackupTest: $localize`Verifying remote data …`,
  Backup_PreviousBackupFinalize: $localize`Completing previous backup …`,
  Backup_ProcessingFiles: $localize`Processing files to backup …`,
  Backup_Finalize: $localize`Completing backup …`,
  Backup_WaitForUpload: $localize`Waiting for upload to finish …`,
  Backup_Delete: $localize`Deleting unwanted files …`,
  Backup_Compact: $localize`Compacting remote data …`,
  Backup_VerificationUpload: $localize`Uploading verification file …`,
  Backup_PostBackupVerify: $localize`Verifying backend data …`,
  Backup_Lock: $localize`Locking remote data …`,
  Backup_PostBackupRestoreTest: $localize`Testing restore of backup …`,
  Backup_Complete: $localize`Backup complete!`,
  Backup_RemoteSynchronization: $localize`Synchronizing secondary destination(s) …`,
  Restore_Begin: $localize`Starting restore …`,
  Restore_RecreateDatabase: $localize`Rebuilding local database …`,
  Restore_PreRestoreVerify: $localize`Verifying remote data …`,
  Restore_CreateFileList: $localize`Building list of files to restore …`,
  Restore_CreateTargetFolders: $localize`Creating target folders …`,
  Restore_ScanForExistingFiles: $localize`Scanning existing files …`,
  Restore_ScanForLocalBlocks: $localize`Scanning for local blocks …`,
  Restore_PatchWithLocalBlocks: $localize`Patching files with local blocks …`,
  Restore_Download: $localize`Downloading files …`,
  Restore_PatchWithRemoteFiles: $localize`Patching files with remote data …`,
  Restore_VerifyRestoredFiles: $localize`Verifying restored files …`,
  Restore_Finalize: $localize`Finalizing restore …`,
  Restore_Complete: $localize`Restore complete!`,
  RestoreTest_Begin: $localize`Starting restore test …`,
  RestoreTest_RecreateDatabase: $localize`Rebuilding temporary database …`,
  RestoreTest_SelectSample: $localize`Selecting files to test …`,
  RestoreTest_Restore: $localize`Restoring sample files …`,
  RestoreTest_Verify: $localize`Verifying restored files …`,
  RestoreTest_CompareSource: $localize`Comparing restored files with source …`,
  RestoreTest_Cleanup: $localize`Cleaning up restore test …`,
  RestoreTest_Complete: $localize`Restore test complete!`,
  Recreate_Begin: $localize`Starting database recreate …`,
  Recreate_Delete: $localize`Deleting old database …`,
  Recreate_Create: $localize`Creating new database …`,
  Recreate_Download: $localize`Downloading files …`,
  Recreate_Process: $localize`Processing files …`,
  Recreate_Complete: $localize`Database recreate complete!`,
  Verify_Begin: $localize`Starting verification …`,
  Verify_Download: $localize`Downloading files …`,
  Verify_Process: $localize`Processing files …`,
  Verify_Complete: $localize`Verification complete!`,
  BugReport_Begin: $localize`Starting bug report …`,
  BugReport_Gathering: $localize`Gathering information …`,
  BugReport_Complete: $localize`Bug report complete!`,
  List_Begin: $localize`Starting list …`,
  List_Download: $localize`Downloading files …`,
  List_Process: $localize`Processing files …`,
  List_Complete: $localize`List complete!`,
  Delete_Begin: $localize`Starting delete …`,
  Delete_Download: $localize`Downloading files …`,
  Delete_Process: $localize`Processing files …`,
  Delete_Complete: $localize`Delete complete!`,
  Compact_Begin: $localize`Starting compact …`,
  Compact_Download: $localize`Downloading files …`,
  Compact_Process: $localize`Processing files …`,
  Compact_Complete: $localize`Compact complete!`,
  Restore_DownloadingRemoteFiles: $localize`Downloading files …`,
  Restore_PostRestoreVerify: $localize`Verifying restored files …`,
  Recreate_Running: $localize`Recreating database …`,
  Vacuum_Running: $localize`Vacuuming database …`,
  Repair_Running: $localize`Repairing database …`,
  Verify_Running: $localize`Verifying files …`,
  BugReport_Running: $localize`Creating bug report …`,
  RunScript_Running: $localize`Running script …`,
  Delete_Listing: $localize`Listing remote files …`,
  Delete_Deleting: $localize`Deleting remote files …`,
  PurgeFiles_Begin: $localize`Listing remote files for purge …`,
  PurgeFiles_Process: $localize`Purging files …`,
  PurgeFiles_Compact: $localize`Compacting remote data …`,
  PurgeFiles_Complete: $localize`Purging files complete!`,
  ReadLockInfo_Running: $localize`Reading lock info …`,
  Sync_Begin: $localize`Starting sync …`,
  Sync_CountingFiles: $localize`Counting files to sync …`,
  Sync_ProcessingFiles: $localize`Processing files to sync …`,
  Sync_WaitForUpload: $localize`Waiting for upload to finish …`,
  Sync_Complete: $localize`Sync complete!`,
  Error: $localize`Error!`,
};

export const resolveStatusText = (phase: string | null | undefined, fallback = '') =>
  phase ? (STATUS_STATES[phase] ?? phase) : fallback;
